import { render, staticRenderFns } from "./VerticalNavMenuItems.vue?vue&type=template&id=f0862518&scoped=true"
import script from "./VerticalNavMenuItems.vue?vue&type=script&lang=js"
export * from "./VerticalNavMenuItems.vue?vue&type=script&lang=js"
import style0 from "./VerticalNavMenuItems.vue?vue&type=style&index=0&id=f0862518&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0862518",
  null
  
)

export default component.exports